// Modale generica "elenco di link" (template-parts/partials/links-modal.php),
// usata dalle card raggruppate dell'archivio Rassegna Stampa e dalle card/slide
// dell'archivio Programmi TV. Un solo listener delegato su document (invece di
// legarsi a un elenco di bottoni/modali raccolto una volta sola all'avvio):
// necessario perché le card raggruppate di Rassegna Stampa arrivano anche via
// innerHTML dalle risposte REST di ricerca/filtro/"Carica altre uscite"
// (assets/js/archivio-rassegna-stampa.js), quindi trigger e modali possono
// comparire nel DOM dopo che initLinksModal() è già girata.

const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

let openModal = null;
let lastFocusedTrigger = null;

// Elementi raggiungibili da tastiera dentro il pannello, nell'ordine del DOM:
// usati dal focus trap qui sotto per capire dove far "rimbalzare" Tab/Shift+Tab.
function getFocusableElements(modal) {
    const panel = modal.querySelector(".links-modal__panel");

    if (!panel) {
        return [];
    }

    return Array.from(panel.querySelectorAll(FOCUSABLE_SELECTOR));
}

// role="dialog" aria-modal="true" (vedi template-parts/partials/links-modal.php)
// promette a chi naviga da tastiera/screen reader che il focus resta dentro
// finché la modale è aperta: senza questo, Tab potrebbe uscire sul resto
// della pagina sottostante, in contraddizione con aria-modal.
function trapFocus(event) {
    if (!openModal || "Tab" !== event.key) {
        return;
    }

    const focusable = getFocusableElements(openModal);

    if (!focusable.length) {
        event.preventDefault();
        return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;

    if (event.shiftKey && (active === first || !openModal.contains(active))) {
        event.preventDefault();
        last.focus();
    } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
    }
}

function closeModal() {
    if (!openModal) {
        return;
    }

    openModal.hidden = true;
    openModal.classList.remove("is-open");
    openModal = null;
    document.body.classList.remove("has-links-modal-open");

    if (lastFocusedTrigger) {
        lastFocusedTrigger.focus();
    }
}

function openModalById(id, trigger) {
    const modal = document.getElementById(id);

    if (!modal) {
        return;
    }

    openModal = modal;
    lastFocusedTrigger = trigger;
    modal.hidden = false;
    // Forza il reflow prima di aggiungere la classe, cosi' la transizione CSS
    // di apertura riparte da zero anche se la modale era gia' stata aperta e
    // richiusa in precedenza.
    void modal.offsetWidth;
    modal.classList.add("is-open");
    document.body.classList.add("has-links-modal-open");

    const closeButton = modal.querySelector("[data-links-modal-close]");
    if (closeButton) {
        closeButton.focus();
    }
}

export function initLinksModal() {
    document.addEventListener("click", (event) => {
        const trigger = event.target.closest("[data-links-modal-trigger]");

        if (trigger) {
            event.preventDefault();
            openModalById(trigger.dataset.linksModalTarget, trigger);
            return;
        }

        if (event.target.closest("[data-links-modal-close]")) {
            closeModal();
        }
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && openModal) {
            closeModal();
            return;
        }

        trapFocus(event);
    });
}
